import config from './config';
import { HttpUserService } from './services/http-user-service';
import { HttpPostService } from './services/http-post-service';
import { HttpCategoryService } from './services/http-category-service';
import { HttpTagService } from './services/http-tag-service';
import { HttpImageService } from './services/http-image-service';
import { HttpMediaService } from './services/http-media-service';

export const userService = new HttpUserService(config.apiUrl);
export const postService = new HttpPostService(config.apiUrl);
export const categoryService = new HttpCategoryService(config.apiUrl);
export const tagService = new HttpTagService(config.apiUrl);
export const imageService = new HttpImageService(config.apiUrl);
export const mediaService = new HttpMediaService(config.apiUrl);
